import React, { ChangeEvent, FC } from 'react';
import { useHistory } from 'react-router-dom';
import Toggle from 'react-toggle';
import { orderDetailsRoute } from 'src/pages/order-details/route';
import { ordersRoute } from 'src/pages/orders/route';
import styled from 'styled-components';
import { DateRangeSearchForm } from '../../components/date-range-form/date-range-search-form';
import { SearchInputForm } from '../../components/search-input-form';
import '../../components/styled-toggle/style.css';
import { IShipTo, ISoldTo } from '../../graphql/types';
import { Black1, White } from '../../styles/colours';
import { DemiBold, Medium } from '../../styles/fonts';

const StyledSearchHeading = styled.div`
  padding: 7.5rem 0rem 2rem 0rem;
  font-size: 1.5rem;
  font-family: ${DemiBold};
  color: ${Black1};
`;

const StyledSearchSection = styled.section`
  @media print {
    display: none;
  }
`;

const StyledSearches = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
  background: ${White};
  padding: 1rem 1rem 1rem 2rem;
  border-radius: 0.25rem;
`;

const StyledOr = styled.span`
  font-family: ${DemiBold};
  font-size: 1.25rem;
  margin: 2rem;
`;

const StyledText = styled.span`
  font-size: 1.125rem;
  font-family: ${Medium};
`;

const StyledToggleContainer = styled.div`
  display: flex;
  gap: 1rem;
  flex-direction: row;
  flex: 1;
  align-items: center;
  padding: 1rem 1rem 1rem 2rem;
  border-radius: 0.25rem;
`;

export const SoldToSearchControls: FC<{
  soldTo: ISoldTo;
  shipTo?: IShipTo;
  firstFiveOrdersToggle: boolean;
  setToggle: any;
}> = ({ soldTo, shipTo, firstFiveOrdersToggle, setToggle }) => {
  const history = useHistory();

  const onSubmitOrderNumber = (e: ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    const orderId = e.target['order-id'].value;
    if (orderId.length > 1) {
      history.push(orderDetailsRoute(soldTo.id, { orderId }));
    }
  };

  const onSubmitPoNumber = (e: ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    const purchaseOrder = e.target['purchase-order'].value;
    if (purchaseOrder.length > 1) {
      history.push(ordersRoute(soldTo.id, { purchaseOrder }));
    }
  };

  return (
    <StyledSearchSection>
      <StyledSearchHeading>Refine your search</StyledSearchHeading>
      <StyledSearches>
        <SearchInputForm
          onSubmit={onSubmitOrderNumber}
          name="order-id"
          placeholder="Search by Shell Order number..."
        />
        <SearchInputForm
          onSubmit={onSubmitPoNumber}
          name="purchase-order"
          placeholder="Search by PO number..."
        />
        <StyledOr> or </StyledOr>
        <DateRangeSearchForm soldToId={soldTo.id} shipToId={shipTo?.id} />
        <StyledToggleContainer>
          <StyledText>Latest five orders</StyledText>
          <Toggle
            icons={false}
            defaultChecked={firstFiveOrdersToggle}
            onChange={setToggle}
          />
        </StyledToggleContainer>
      </StyledSearches>
    </StyledSearchSection>
  );
};
